module.exports = __webpack_public_path__ + "img/2f221f5.svg";